<template lang="pug">
  v-radio-group(
    row,
    v-bind="$attrs",
    :rules="required ? [v => !!v || label + ' is required'] : []",
    :value='value',
    @change="$emit('update:value', $event)",
  )
    template(v-slot:label)
      div.full-width.mb-2 {{ label }}
    v-radio(
      v-for="(item, key) in list",
      :key="item.value + key"
      :label='item.label',
      :value='item.value',
    )
</template>

<script>
export default {
  props: {
    value: {
      validator: prop =>
        typeof prop === 'string' || prop === null || prop === undefined,
      required: true,
    },
    list: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
